import React, { useContext, useEffect, useMemo } from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UiContext } from "../contexts/UiContext";
import { createAwTheme } from "../theme/createAwTheme";

const cacheRtl = createCache({
  key: "mui-rtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const cacheLtr = createCache({
  key: "mui",
  stylisPlugins: [prefixer],
});

function isRtlLang(lng) {
  return ["he", "ar", "fa", "ur"].includes(String(lng || "").toLowerCase());
}

export default function I18nMuiProvider({ children }) {
  const { i18n } = useTranslation();
  const ui = useContext(UiContext);
  const direction = isRtlLang(i18n.language) ? "rtl" : "ltr";
  const mode = ui?.mode || "light";

  const theme = useMemo(() => createAwTheme({ direction, mode }), [direction, mode]);

  const cache = direction === "rtl" ? cacheRtl : cacheLtr;

  useEffect(() => {
    document.documentElement.dir = direction;
    document.documentElement.lang = i18n.language || "he";
  }, [direction, i18n.language]);

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
}


